import { IconButton, IconButtonProps } from '@mui/material';

import CloseXIcon from 'modules/common/components/Icons/CloseXIcon';

function DialogCloseButton({ onClick = () => {}, ...props }: { onClick?: () => void } & IconButtonProps) {
    return (
        <IconButton
            {...props}
            onClick={onClick}
            // Defaults to top-right absolute placement. A caller's `sx` is merged last, so a
            // dialog with a flex title can override `position`/`top`/`right` to flow it inline.
            sx={{
                position: 'absolute',
                right: 16,
                top: 16,
                color: 'cement.700',
                backgroundColor: 'cement.100',
                ...props.sx,
            }}>
            <CloseXIcon />
        </IconButton>
    );
}

export default DialogCloseButton;
